import { Component, Input, OnInit, signal } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Meta } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { SettingsService } from "src/app/settings/settings.service";
import { AgendarOnboarding } from "../agendar/agendar";
import { DetalleFacturas } from "src/app/home/cliente-new-version/detalle-facturas/detalle-facturas";
import { MatTableDataSource } from "@angular/material/table";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";


declare var $: any;

@Component({
    selector: 'app-info-modal',
    templateUrl: './info-modal.html',
    styleUrls: ['./info-modal.less'],
    standalone: false
})
export class InfoModalOnboarding implements OnInit {

  @Input() step:any;
  @Input() id_simulation: any;
  id_company = localStorage.getItem('company_id');
  contacto:any="";
  avalEmail: any="";
  firmanteName: any="";
  firmanteId: any="";
  firmanteEditar: any="";
  contactForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<InfoModalOnboarding>, 
    public settings: SettingsService, 
    public dialog: MatDialog, 
    private metaTagService: Meta, 
    public route:Router,
    private fb: FormBuilder,
  ) { 
    this.contactForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      telefono: ['', [Validators.required, Validators.pattern(/^[0-9]{9}$/)]],
    });

  }

  ngOnInit() {

    if(this.step == 12){
      this.get_deudores_calificados();
    } else if(this.step == 17){
      this.get_facturas();
      this.get_simulation();
    }

    if (this.step == 29) {
      this.contactForm.patchValue({
        email: this.firmanteEditar.email || '',
        telefono: this.firmanteEditar.telefono || ''
      });
    }


    console.error("aqui paso", this.step)

  }

  ingresar_al_sii(){
    window.open("https://zeusr.sii.cl//AUT2000/InicioAutenticacion/IngresoRutClave.html?https://misiir.sii.cl/cgi_misii/siihome.cgi", "_blank")
  }

  agendar() {
    console.log("a")
    let dialogRef = this.dialog.open(AgendarOnboarding, {
      width: '700px',
      minHeight: '600px',
      autoFocus: false,
    });


  }

  continue(){
    this.dialogRef.close(true)
  }

  reintentar(){
    this.dialogRef.close('retry')
  }

  continuar_agregar(){
    this.dialogRef.close('add')
  }

  continue_six(){
    this.dialogRef.close('six')
  }

  continue_documentacion(){
    this.dialogRef.close('continue_documentacion')
  }

  continue_revision(){
    this.dialogRef.close('continue_revision')
  }




  open_modal_info(step:any) {
    let dialogRef = this.dialog.open(InfoModalOnboarding, {
      width: '700px',
      autoFocus: false,
    });

    dialogRef.componentInstance.step = step;
    dialogRef.componentInstance.contacto = this.contacto;


  }

  deudores:any[]=[];
  loading_deudores:boolean=false;
  async get_deudores_calificados(){


    try {

      this.deudores = [];
      this.loading_deudores = true;
      const bd: any = await this.settings.get_query(1, '/onboarding/deudores-calificados/'+this.id_company+'/');
      var body_data: any =bd._body;
      var data = body_data.success;
      switch (bd.status) {
        case 200:
 
          this.deudores = data.info
          this.loading_deudores = false;
          


        break;
        }

    } catch (bd:any) {

      this.loading_deudores = false;

    }

  }

  ir_a_ux(){
    window.open("https://wa.me/56934677786", "__blank")
  }

  cantidad_facturas:any=0;
  loading_cantidad:boolean=false;
  pageLength = 0;
  pageSize = 7;
  pageIndex = 0;
  page = 1;
  filtro:any="";
  loading_facturas:boolean=false;
  facturas:any[]=[];
  ELEMENT_DATA: any[] = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);

  async get_facturas(){
    try {
      this.loading_facturas = true;
      this.facturas = [];

      const bd: any = await this.settings.get_query(1, '/cliente/simulacion-documentos/'+this.id_simulation+'/?page='+this.page+'&filtro='+this.filtro);
      var body_data: any =bd._body;
      var data = body_data.success;

      switch (bd.status) {
        case 200:
          this.cantidad_facturas = data.total;
          this.facturas = data.info;
          this.loading_facturas = false;
          
          console.log(this.facturas)

          setTimeout(() => {
            this.dataSource = new MatTableDataSource(this.facturas);
            this.dataSource._updateChangeSubscription();
          });

        break;
        }
    } catch (bd:any) {

    }
  }

  detalle_factura(){
    const dialogRef = this.dialog.open(DetalleFacturas,{
      width: '600px',
      disableClose: true,
      autoFocus: false,
    });
    dialogRef.componentInstance.id_sim = this.id_simulation;
  }

  monto_simulado:any=0;
  porcentaje_financiamiento:any=0;
  monto_anticipo:any=0;
  dias_promedio:any=0;
  loading:boolean=false;

  async get_simulation(){
    try {
      this.loading = true;

      const bd: any = await this.settings.get_query(1, `/cliente/simulacion/${this.id_simulation}/`);
      var body_data: any =bd._body;
      switch (bd.status) {
        case 200:
          console.log("simulation info", body_data)

          let sim = body_data.success.info;
          this.monto_simulado = sim.total;
          this.porcentaje_financiamiento = sim.anticipo;
          this.monto_anticipo = sim.valor_anticipo_total;
          this.dias_promedio = sim.dias_promedio;

          this.loading = false;

        break;

        default:
        break;
      }

    } catch (bd:any) {
    }
  }

  readonly panelOpenState = signal(false);

  guardarDatosFirmante() {
    if (this.contactForm.valid && this.firmanteEditar) {
      const firmante = {
        ...this.firmanteEditar,
        email: this.contactForm.value.email,
        telefono: this.contactForm.value.telefono
      };
      
      this.dialogRef.close({
        updated: true,
        firmante: firmante
      });
    }
  }
}